import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Request from "./Request";
import RequisitionAction from '../../../../../Store/Component/Requisition/RequisitionAction';
import { IReason } from '../../../../../Model/IReason'
import { initializeReason, resetReason,resetOrderRequest, resetReasonDealerdetail } from "client/utils/RequisitionUtil";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import RequisitionValidation from "../RequisitionValidation"
import { CONSTANTS } from "client/utils/constants";
import { APIToReact } from 'Service/OrderManagement/ObjectStructure';
import { useNavigate } from "react-router-dom";
import navOperations from "redux/Navigation/operations";
import RejectedBee from "../../../../assets/images/PenndingApproval/Rejected Bee.png";
import selectors from "redux/Navigation/selectors";
import pendingOrderOperations from 'redux/PendingOrder/operations';
import { getVendorDetails } from 'Store/Organization/VendorDetails/VendorDetailsAction';
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { setEmployeeReasonInfo } from "Store/OrderManagement/EmployeeInfo/EmployeeInfoAction";
import userProfileSelectors from 'redux/UserProfile/selectors';
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch'
import { setDeleteCartOrder } from "Store/OrderManagement/Order/OrderAction";

const ItemDetailsContainer = (props: any) => {

  //local props
  const mobile = props.mobile;
  const setShowCartClicked = props.setShowCartClicked;
  const setShowCart = props.setShowCart;
  const setShowCreateRequisition = props.setShowCreateRequisition;
  const setSuccessAlert = props.setSuccessAlert;
  const showCatalog = props?.showCatalog;
  const setIsRequestDeleted = props?.setIsRequestDeleted;
  const isRequestDeleted = props?.isRequestDeleted;
  const setIsReasonDeleted = props?.setIsReasonDeleted;
  const isReasonDeleted = props?.isReasonDeleted;
  const setIsDealerChangesOccured = props?.setIsDealerChangesOccured;
  const isDealerChangesOccured = props?.isDealerChangesOccured;

  //local state
  const [requestListTemp, setRequestListTemp] = useState([]);
  const [productionVehicleListTemp, setProductionVehicleListTemp] = useState([]);
  const [managedEquipmentListTemp, setManagedEquipmentListTemp] = useState([]);
  const [nonStandardEquipmentListTemp, setNonStandardEquipmentListTemp] = useState([]);
  const [managementVehicleListTemp, setManagementVehicleListTemp] = useState([]);
  const [reasonListTemp, setReasonListTemp] = useState([]);
  const [isAttachmentRequired, setIsAttachmentRequired] = useState(false);

  const [selectedProductionAccordion, setSelectedProductionAccordion] = useState<any>([]);
  const [selectedManagementAccordion, setSelectedManagementAccordion] = useState<any>([]);
  const [selectedManagedAccordion, setSelectedManagedAccordion] = useState<any>([]);
  const [selectedNonStandardAccordion, setSelectedNonStandardAccordion] = useState<any>([]);

  const [quotePriceToggleBtn, setQuotePriceToggleBtn] = useState(false)
  const [isCancelClicked, setIsCancelClicked] = useState<any>(false)

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
    popupOutlinebtnOnclick: () => { },
  });
  // const [showReasonValidation, setShowReasonValidation] = useState(false)
  const itemDetailRef = useRef<any>([]);
  const [attachmentsList, setAttachmentsList] = useState<any>([]);
  const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
  const [isDriverAttachmentBtnClicked, setIsDriverAttachmentBtnClicked] = useState<any>([]);
  const [collapse, setCollapse] = useState(false)
  const [MandAcheck, setMandAcheck] = useState(false)
  const wrapperRef = useRef<any>(requestListTemp);
  const [headerNavItem, setHeaderNavItem] = useState("home");
  const [approvalAction, setApprovalAction] = useState<any>({
    actionby: "",
    cancelorderFailed: ""
  });
  const [isOrderCancel, setisOrderedCanceled] = useState<any>(false);
  const [isCancelPopup, setIsCancelPopup] = useState<any>(false)
  ///dispatch
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchActionPopupValue = pendingOrderOperations.dispatchActionPopup(dispatch);
  const dispatchSetAttachments = UploadAttachmentsDispatch.dispatchSetAttachments(dispatch)
  const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);

  ///selectors
  const { selectedRequisitionType,
    requestList,
    productionVehicleList,
    reasonList,
    requestCartList,
    productionVehicleCartList,
    reasonCartList,
    showItemDetails,
    managedEquipmentList,
    managedEquipmentCartList,
    nonStandardEquipmentList,
    nonStandardEquipmentCartList,
    managementVehicleList,
    managementVehicleCartList,
    orderByIdValue,
    isEditOrder,
    headerNav,
    actionPopupValue,
    isOrderCanceled,
    selectedCatalogItem,
    isApprovalOverrideFlag,
    userDetails,
    cartOrderDelete,
    isDealerSameForAllFlag
    }: any = useSelector((state?: any) => ({
      reasonTypeDropdown: state.ReasonType.reasonTypeDropDown,
      requestList: state.RequisitionReducer.requestList,
      productionVehicleList: state.RequisitionReducer.productionVehicleList,
      nonStandardEquipmentList: state.RequisitionReducer.nonStandardEquipmentList,
      managementVehicleList: state.RequisitionReducer.managementVehicleList,
      reasonList: state.RequisitionReducer.reasonList,
      requestCartList: state.RequisitionReducer.requestCartList,
      productionVehicleCartList: state.RequisitionReducer.productionVehicleCartList,
      nonStandardEquipmentCartList: state.RequisitionReducer.nonStandardEquipmentCartList,
      managementVehicleCartList: state.RequisitionReducer.managementVehicleCartList,
      reasonCartList: state.RequisitionReducer.reasonCartList,
      showItemDetails: state.RequisitionReducer.showItemDetails,
      isAddToCartClick: state.RequisitionReducer.isAddToCartClick,
      isReasonChange: state.RequisitionReducer.isReasonChange,
      selectedRequisitionType: state.RequisitionReducer.selectedRequisitionType,
      managedEquipmentList: state.RequisitionReducer.managedEquipmentList,
      managedEquipmentCartList: state.RequisitionReducer.managedEquipmentCartList,
      orderByIdValue: state.OrderReducer.orderByIdData,
      isSaveClick: state.RequisitionReducer.isSaveClick,
      isEditOrder: state.RequisitionReducer.isEditOrder,
      isMandAFlag: state.RequisitionReducer.isMandAFlag,
      headerNav: selectors.GetHeaderNav(state),
      actionPopupValue: state.PendingOrder.actionPopupValue,
      isOrderCanceled: state.PendingOrder.isOrderCanceled,
      productionVehicleDangerouslySetExpandedList : state.RequisitionReducer.productionVehicleDangerouslySetExpandedList,
      selectedCatalogItem: state.RequisitionReducer.selectedCatalogItem,
      editRequestDetails: state.RequisitionReducer.editRequestDetails,
      isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
      vendorDetails: state.VendorDetailsReducer.vendorDropDownList,
      isApprovalOverrideFlag: state.RequisitionReducer.isApprovalOverrideFlag,
      userDetails: userProfileSelectors.getUserDetails(state),
      cartOrderDelete: state.OrderReducer.cartOrderDelete,
      isDealerSameForAllFlag : state.RequisitionReducer.isDealerSameForAllFlag
    }));

  const plannedRef = useRef<any>([]);

  useEffect(() => {
    setRequestListTemp(requestList);
    setProductionVehicleListTemp(productionVehicleList);
    setNonStandardEquipmentListTemp(nonStandardEquipmentList);
    setReasonListTemp(reasonList);
    setManagedEquipmentListTemp(managedEquipmentList)
    setManagementVehicleListTemp(managementVehicleList)
  }, [requestList, productionVehicleList, reasonList, managedEquipmentList, nonStandardEquipmentList, managementVehicleList])

  useEffect(() => {
    if (!mobile) {
      document?.getElementsByClassName('item-details-requisition')[0]?.classList?.remove('addedHeight');
    }
  }, [mobile])

  useEffect(() => {

    if (mobile && showItemDetails) {
      setTimeout(() => {
        document?.getElementsByClassName('vehicleTypeAccord')[0]?.classList?.remove('addedHeight');
        document?.getElementsByClassName('item-details-requisition')[0]?.classList?.add('addedHeight');
      }, 500)
    }
  }, [mobile, showItemDetails, selectedRequisitionType, requestList])

  useEffect(() => {

    if (mobile && showItemDetails) {
      setTimeout(() => {
        const elem = document.getElementsByClassName('item-details-requisition')[0] as HTMLElement;
        const top = elem?.offsetTop;
        document.getElementsByClassName('content-wrapper')[0].scrollTop = top - 10
      }, 500)
    }
  }, [mobile, showItemDetails, requestList])

  useEffect(() => {
    if (managedEquipmentList?.length > 0) {
      for (let i = 0; i < managedEquipmentList?.length; i++) {
        if (managedEquipmentList[i]?.requestType == CONSTANTS.MANAGED_EQUIPMENT && managedEquipmentList[i]?.showQuotePrice) {
          setIsAttachmentRequired(true)
          return
        } else {
          setIsAttachmentRequired(false)
        }
      }
    }
  }, [reasonList, requestList])

  useEffect(() => {
    setMandAcheck(!!orderByIdValue.isMandAFlag);
    dispatch(RequisitionAction.setIsMandFlag(!!orderByIdValue.isMandAFlag))
    dispatch(RequisitionAction.setIsApprovalOverrideFlag(orderByIdValue.isApprovalOverrideFlag))
    dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(orderByIdValue.isDealerSame))
  }, [orderByIdValue])

  const onClickResetReason = (e: any, reason: any) => {
    e.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true))
    dispatch(RequisitionAction.setIsReasonChange(true));
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    dispatch(getVendorDetails(""))
    let isValidToResetAll = reason?.isDisabled
    let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < requestListTemp1.length; i++) {
      if(requestListTemp1[i]?.requestType === CONSTANTS?.MANAGED_EQUIPMENT && !isValidToResetAll && isDealerSameForAllFlag && reason?.requestType === CONSTANTS?.MANAGED_EQUIPMENT){
        requestListTemp1[i] = resetReasonDealerdetail(requestListTemp1[i]);
    }
      if (requestListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
        if (reason.isDisable){
          requestListTemp1[i] = resetReasonDealerdetail(requestListTemp1[i]);
        }
        requestListTemp1[i] = resetReason(requestListTemp1[i]);
        if (reason?.requestType === CONSTANTS.MANAGEMENT_VEHICLE || reason?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
          requestListTemp1[i].showQuotePrice = false;
        }
      }
    }
    dispatch(RequisitionAction.setIReason(requestListTemp1))
  }

  const onClickDeleteReason = (e: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    let reasonCount = 0;
    for (let i = 0; i < requestListTemp1.length; i++) {
      if (requestListTemp1[i]?.requestIndex === reason?.requestIndex) {
        reasonCount = reasonCount + 1
      }
    }
    if (reasonCount == 1) {
      let decriptionTxt = (
        <p>Request must contain atleast one reason.</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "Information",
        isDialogVisible: true,
        isTitleWarning: false,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
      });
    }
    else {
      //delete reason
      for (let i = 0; i < requestListTemp1.length; i++) {
        if (requestListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
          if(requestListTemp1[i]?.requestType === CONSTANTS.MANAGED_EQUIPMENT && isDealerSameForAllFlag){
            setIsReasonDeleted(true);
            if((checkManagedEquipCount() - 1)<= 1){
              dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(false))
            }
          }
          requestListTemp1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIReason(requestListTemp1))

      //delete cart reason
      let reasonCartListTemp = reasonCartList?.length > 0 ? JSON.parse(JSON.stringify(reasonCartList)) : [];
      for (let i = 0; i < reasonCartListTemp.length; i++) {
        if (reasonCartListTemp[i]?.reasonIndex === reason?.reasonIndex) {
          reasonCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIReason(reasonCartListTemp))

      //check driverDetailList on delete a reason
      validateDriverList(reason?.requestIndex, requestListTemp1)

      if (reason?.showQuotePrice) {
        let previousprice = 0;
        for (let i = 0; i < requestListTemp1.length; i++) {
          if (requestListTemp1[i]?.requestIndex === reason?.requestIndex) {

            let val = parseFloat(requestListTemp1[i]?.estimatedPrice?.replace(/,/g, "")).toFixed(2)
            previousprice = previousprice + parseFloat(val);
          }
        }
        let managedEquipmentListTemp = managedEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentList)) : [];
        for (let i = 0; i < managedEquipmentListTemp?.length; i++) {
          if (managedEquipmentListTemp[i]?.requestIndex === reason?.requestIndex) {
            managedEquipmentListTemp[i].price = previousprice;
          }
        }
        dispatch(RequisitionAction.setIManagedEquipment(managedEquipmentListTemp));
        let managedEquipmentCartListTemp = managedEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentCartList)) : [];
        for (let i = 0; i < managedEquipmentCartListTemp?.length; i++) {
          if (managedEquipmentCartListTemp[i]?.requestIndex === reason?.requestIndex) {
            managedEquipmentCartListTemp[i].price = previousprice;
          }
        }
        dispatch(RequisitionAction.setCartIManagedEquipment(managedEquipmentCartListTemp));
      }
    }
  }

  const validateDriverList = (requestIndex: any, reasonList: any) => {
    let managementVehicleListtemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];

    for (let i = 0; i < managementVehicleListtemp.length; i++) {
      if (managementVehicleListtemp[i]?.requestIndex === requestIndex) {
        let isDriver = RequisitionValidation.ValidateVehicleDriverDetails(managementVehicleListtemp[i], reasonList);
        managementVehicleListtemp[i].vehicleDriverDetailsError = isDriver?.request?.vehicleDriverDetailsError;
      }
    }
    dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListtemp))
  }

  const onClickAddReason = (e: any, request: any) => {
    e.stopPropagation();

    if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      return;
    }

    dispatch(RequisitionAction.setIsChangesOccured(true))
    // setShowReasonValidation(false)
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];  
    let nextReasonIndex = 0;
    requestListTemp1.forEach((item : any) => {
      if (item?.reasonIndex > nextReasonIndex) {
        nextReasonIndex = item?.reasonIndex;
      }
    });
    nextReasonIndex = nextReasonIndex + 1;

    // for (let i = 0; i < productionVehicleList1.length; i++) {
    //   if (productionVehicleList1[i].requestIndex === request.requestIndex) {
    //     productionVehicleList1[i].quantity = productionVehicleList1[i].quantity + 1;
    //   }
    // }
    // dispatch(RequisitionAction.setIProductionVehicle(productionVehicleList1))

    const reason: IReason = initializeReason(request, nextReasonIndex);
    if(isDealerSameForAllFlag && request?.requestType == CONSTANTS.MANAGED_EQUIPMENT){
      const managedEquipmentReasons = reasonList?.filter(
        (r: any) => r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
      );
    
      const firstManagedEquipmentReason = managedEquipmentReasons[0];

      reason.isDisabled= true
      reason.name = firstManagedEquipmentReason?.name
      reason.contact= firstManagedEquipmentReason?.contact
      reason.phone = firstManagedEquipmentReason?.phone
      reason.email= firstManagedEquipmentReason?.email
      reason.addressLine1 = firstManagedEquipmentReason?.addressLine1
      reason.addressLine2 = firstManagedEquipmentReason?.addressLine2
      reason.addressLine3 = firstManagedEquipmentReason?.addressLine3
      reason.city = firstManagedEquipmentReason?.city
      reason.state = firstManagedEquipmentReason?.state
      reason.zipCode = firstManagedEquipmentReason?.zipCode
    }
    requestListTemp1.push(reason);
    dispatch(RequisitionAction.setIReason(requestListTemp1));

    //check driverDetailList on adding reason
    validateDriverList(request?.requestIndex, requestListTemp1);
  }

  const onClickDeleteRequest = (e: any, request: any) => {
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsChangesOccured(true))
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    //delete request
    let requestList1 = requestList?.length > 0 ? JSON.parse(JSON.stringify(requestList)) : [];
    for (let i = 0; i < requestList1.length; i++) {
      if (requestList1[i]?.requestIndex === request?.requestIndex) {
        requestList1.splice(i, 1);
      }
    }
    dispatch(RequisitionAction.setIRequest(requestList1))

    //clear the attachments for zero request
    if (requestList1?.length === 0) {
      dispatchSetAttachments([]);
    }
    //Delete vehicle

    if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
      let productionVehicleList1 = productionVehicleList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleList)) : [];
      for (let i = 0; i < productionVehicleList1.length; i++) {
        if (productionVehicleList1[i]?.requestIndex === request?.requestIndex) {
          productionVehicleList1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIProductionVehicle(productionVehicleList1))
    } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      let nonStandardEquipmentList1 = nonStandardEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentList)) : [];
      for (let i = 0; i < nonStandardEquipmentList1.length; i++) {
        if (nonStandardEquipmentList1[i]?.requestIndex === request?.requestIndex) {
          nonStandardEquipmentList1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setINonStandardEquipment(nonStandardEquipmentList1))
    } else if (request?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
      let managedEquipmentListtemp = managedEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentList)) : [];
      for (let i = 0; i < managedEquipmentListtemp.length; i++) {
        if (managedEquipmentListtemp[i]?.requestIndex === request?.requestIndex) {
          
          if(isDealerSameForAllFlag ){
            let requestReasonLength = reasonList?.filter((item?: any) => item?.requestIndex === request?.requestIndex)?.length
            if((checkManagedEquipCount() - requestReasonLength) <= 1){
              dispatch(RequisitionAction?.setIsDealerSameForAllFlagFlag(false))
            }
          setIsRequestDeleted(true)
          }
          managedEquipmentListtemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIManagedEquipment(managedEquipmentListtemp))
    } else if (request?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
      let managementVehicleListtemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];
      for (let i = 0; i < managementVehicleListtemp.length; i++) {
        if (managementVehicleListtemp[i]?.requestIndex === request?.requestIndex) {
          managementVehicleListtemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListtemp))
    }

    //delete reason
    let reasonList1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

    let index = reasonList1.length - 1;
    while (index >= 0) {
      if (reasonList1[index]?.requestIndex === request?.requestIndex) {
        reasonList1.splice(index, 1);
      }
      index -= 1;
    }
    dispatch(RequisitionAction.setIReason(reasonList1))

    //delete request from cart   
    let requestCartListTemp = requestCartList?.length > 0 ? JSON.parse(JSON.stringify(requestCartList)) : [];
    for (let i = 0; i < requestCartListTemp.length; i++) {
      if (requestCartListTemp[i]?.requestIndex === request?.requestIndex) {
        requestCartListTemp.splice(i, 1);
      }
    }
    dispatch(RequisitionAction.setCartIRequest(requestCartListTemp))

    //Delete vehicle and equipment from cart      
    if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
      let productionVehicleCartListTemp = productionVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleCartList)) : [];
      for (let i = 0; i < productionVehicleCartListTemp.length; i++) {
        if (productionVehicleCartListTemp[i]?.requestIndex === request?.requestIndex) {
          productionVehicleCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIProductionVehicle(productionVehicleCartListTemp))
    } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      let nonStandardEquipmentCartListTemp = nonStandardEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentCartList)) : [];
      for (let i = 0; i < nonStandardEquipmentCartListTemp.length; i++) {
        if (nonStandardEquipmentCartListTemp[i]?.requestIndex === request?.requestIndex) {
          nonStandardEquipmentCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartINonStandardEquipment(nonStandardEquipmentCartListTemp))
    } else if (request?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
      let managedEquipmentCartListTemp = managedEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentCartList)) : [];
      for (let i = 0; i < managedEquipmentCartListTemp.length; i++) {
        if (managedEquipmentCartListTemp[i]?.requestIndex === request?.requestIndex) {
          managedEquipmentCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIManagedEquipment(managedEquipmentCartListTemp))
    } else if (request?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
      let managementVehicleCartListTemp = managementVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleCartList)) : [];
      for (let i = 0; i < managementVehicleCartListTemp.length; i++) {
        if (managementVehicleCartListTemp[i]?.requestIndex === request?.requestIndex) {
          managementVehicleCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIManagementVehicle(managementVehicleCartListTemp))
    }

    //delete reason from cart     
    let reasonCartListTemp = reasonCartList?.length > 0 ? JSON.parse(JSON.stringify(reasonCartList)) : [];
    let indexCart = reasonCartListTemp.length - 1;
    while (indexCart >= 0) {
      if (reasonCartListTemp[indexCart].requestIndex === request?.requestIndex) {
        reasonCartListTemp.splice(indexCart, 1);
      }
      indexCart -= 1;
    }
    dispatch(RequisitionAction.setCartIReason(reasonCartListTemp))

    //unselect catalog item after deleting the request

    let remainingCatalogItem = selectedCatalogItem?.length > 0 ? JSON.parse(JSON.stringify(selectedCatalogItem)) : [];

    remainingCatalogItem.forEach((item: any, index: any) => {
      if (request?.assetModelId === item.assetModelId) {
        item.isSelected = false
      }
    })
    dispatch(RequisitionAction.setSelectedCatalogItem(remainingCatalogItem))
  }

  useEffect(() => {
    if (props.showCartClicked) {
      if (mobile) {
        setShowCart(true);
        setShowCreateRequisition(false)
      }
      else {
        setShowCart(true);
        setShowCreateRequisition(true)
      }
    }
  }, [props.showCartClicked, mobile])

  const setValidationPopupForReason = () => {
    let decriptionTxt = (
      <>
        <p>Please fill all the reasons.</p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Ok",
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isSingleConfirmationBtn: true,
    });
  }

  const onClickAddToCart = (request: any) => {  
    dispatch(RequisitionAction.setIsUpdateSuccessAlert(false))
    dispatch(RequisitionAction.setIsChangesOccured(true))
    dispatch(setEmployeeReasonInfo({}))
    //validate all reason and save to state
    let reasonListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < reasonListTemp1.length; i++) {
      if (reasonListTemp1[i]?.requestIndex === request?.requestIndex) {
        reasonListTemp1[i] = RequisitionValidation.ValidateReason(reasonListTemp1[i]);
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp1))

  
    let isValid = true;
    if (request?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
      let isDriver = RequisitionValidation.ValidateVehicleDriverDetails(request, reasonList);
      let managementVehicleListTemp1 = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];
      for (let i = 0; i < managementVehicleListTemp1?.length; i++) {
        if (managementVehicleListTemp1[i]?.requestIndex === request?.requestIndex) {
          managementVehicleListTemp1[i].vehicleDriverDetailsError = isDriver.request?.vehicleDriverDetailsError;
        }
      }
      dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListTemp1))
      if (!isDriver.isValid) {
        isValid = false
        mobile && setValidationPopupForReason();
        return
      }
    }
    for (let i = 0; i < reasonListTemp1.length; i++) {
      if (reasonListTemp1[i]?.requestIndex === request?.requestIndex) {
        if (!reasonListTemp1[i]?.isValid) {
          // setShowReasonValidation(true)
          isValid = false;
          mobile && setValidationPopupForReason();
          setSelectedProductionAccordion([`requestReason_Production${[i]}`])
          setSelectedManagementAccordion([`requestReason_Management${[i]}`])
          setSelectedManagedAccordion([`requestReason_Managed${[i]}`])
          setSelectedNonStandardAccordion([`requestReason_NonStandard${[i]}`])
          return
        }
      }
    }

    if (isValid) {
      //to hide reason validation message
      // setShowReasonValidation(false)
      //change status 
      if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
        let productionVehicleListTemp = productionVehicleList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleList)) : [];
        for (let i = 0; i < productionVehicleListTemp?.length; i++) {
          if (productionVehicleListTemp[i]?.requestIndex === request?.requestIndex) {
            productionVehicleListTemp[i].isExistInCart = true;
          }
        }
        dispatch(RequisitionAction.setIProductionVehicle(productionVehicleListTemp))
        dispatch(RequisitionAction.setProductionVehicleDangerouslySetExpanded([]))
      } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
        let nonStandardEquipmentListTemp = nonStandardEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentList)) : [];
        for (let i = 0; i < nonStandardEquipmentListTemp?.length; i++) {
          if (nonStandardEquipmentListTemp[i]?.requestIndex === request?.requestIndex) {
            nonStandardEquipmentListTemp[i].isExistInCart = true;
          }
        }
        dispatch(RequisitionAction.setINonStandardEquipment(nonStandardEquipmentListTemp))
      } else if (request?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
        let managedEquipmentListTemp = managedEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentList)) : [];
        for (let i = 0; i < managedEquipmentListTemp?.length; i++) {
          if (managedEquipmentListTemp[i]?.requestIndex === request?.requestIndex) {
            managedEquipmentListTemp[i].isExistInCart = true;
          }
        }
        dispatch(RequisitionAction.setIManagedEquipment(managedEquipmentListTemp))
      } else if (request?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
        let managementVehicleListTemp1 = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];
        for (let i = 0; i < managementVehicleListTemp1?.length; i++) {
          if (managementVehicleListTemp1[i]?.requestIndex === request?.requestIndex) {
            managementVehicleListTemp1[i].isExistInCart = true;
          }
        }
        dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListTemp1))
      }


      //check exist or not
      let isExist = false;
      for (let i = 0; i < requestCartList?.length; i++) {
        if (requestCartList[i]?.requestIndex === request?.requestIndex) {
          isExist = true;
        }
      }

      //take copy
      let requestCartListTemp = requestCartList?.length > 0 ? JSON.parse(JSON.stringify(requestCartList)) : [];
      let productionVehicleCartListTemp = productionVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleCartList)) : [];
      let nonStandardEquipmentCartListTemp = nonStandardEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentCartList)) : [];
      let managedEquipmentCartListTemp = managedEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentCartList)) : [];
      let managementVehicleCartListTemp = managementVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleCartList)) : [];
      let reasonCartListTemp = reasonCartList?.length > 0 ? JSON.parse(JSON.stringify(reasonCartList)) : [];

      if (isExist) {

        //delete request      
        for (let i = 0; i < requestCartListTemp.length; i++) {
          if (requestCartListTemp[i]?.requestIndex === request?.requestIndex) {
            requestCartListTemp.splice(i, 1);
          }
        }

        //Delete vehicle/equipment  
        if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
          for (let i = 0; i < productionVehicleCartListTemp.length; i++) {
            if (productionVehicleCartListTemp[i]?.requestIndex === request?.requestIndex) {
              productionVehicleCartListTemp.splice(i, 1);
            }
          }
        } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
          for (let i = 0; i < nonStandardEquipmentCartListTemp.length; i++) {
            if (nonStandardEquipmentCartListTemp[i]?.requestIndex === request?.requestIndex) {
              nonStandardEquipmentCartListTemp.splice(i, 1);
            }
          }
        } else if (request?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
          for (let i = 0; i < managedEquipmentCartListTemp.length; i++) {
            if (managedEquipmentCartListTemp[i]?.requestIndex === request?.requestIndex) {
              managedEquipmentCartListTemp.splice(i, 1);
            }
          }
        } else if (request?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
          for (let i = 0; i < managementVehicleCartListTemp.length; i++) {
            if (managementVehicleCartListTemp[i]?.requestIndex === request?.requestIndex) {
              managementVehicleCartListTemp.splice(i, 1);
            }
          }
        }

        //delete reason      
        let index = reasonCartListTemp.length - 1;
        while (index >= 0) {
          if (reasonCartListTemp[index].requestIndex === request?.requestIndex) {
            reasonCartListTemp.splice(index, 1);
          }
          index -= 1;
        }

      }

      //Request    
      for (let i = 0; i < requestList.length; i++) {
        if (requestList[i]?.requestIndex === request?.requestIndex) {
          let item = { ...requestList[i] }
          requestCartListTemp.push(item)
        }
      }
      dispatch(RequisitionAction.setCartIRequest(requestCartListTemp))

      //Production Vehicle    
      if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
        for (let i = 0; i < productionVehicleList?.length; i++) {
          if (productionVehicleList[i]?.requestIndex === request?.requestIndex) {
            let item = { ...productionVehicleList[i] }
            productionVehicleCartListTemp.unshift(item)
          }
        }
        dispatch(RequisitionAction.setCartIProductionVehicle(productionVehicleCartListTemp))
      } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
        //Non Standard Equipment    
        for (let i = 0; i < nonStandardEquipmentList?.length; i++) {
          if (nonStandardEquipmentList[i]?.requestIndex === request?.requestIndex) {
            let item = { ...nonStandardEquipmentList[i] }
            nonStandardEquipmentCartListTemp.unshift(item)
          }
        }
        dispatch(RequisitionAction.setCartINonStandardEquipment(nonStandardEquipmentCartListTemp))
      } else if (request?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
        for (let i = 0; i < managedEquipmentList.length; i++) {
          if (managedEquipmentList[i]?.requestIndex === request?.requestIndex) {
            let item = { ...managedEquipmentList[i] }
            managedEquipmentCartListTemp.unshift(item)
          }
        }
        dispatch(RequisitionAction.setCartIManagedEquipment(managedEquipmentCartListTemp))
      } else if (request?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
        for (let i = 0; i < managementVehicleList.length; i++) {
          if (managementVehicleList[i]?.requestIndex === request?.requestIndex) {
            let item = { ...managementVehicleList[i] }
            managementVehicleCartListTemp.unshift(item)
          }
        }
        dispatch(RequisitionAction.setCartIManagementVehicle(managementVehicleCartListTemp))
      }

      //Reason    
      for (let i = 0; i < reasonListTemp1.length; i++) {
        if (reasonListTemp1[i]?.requestIndex === request?.requestIndex) {
          let item = { ...reasonListTemp1[i] }
          reasonCartListTemp.push(item)
        }
      }
      dispatch(RequisitionAction.setIsAddToCartClick(true));
      setSuccessAlert(true)
      setShowCartClicked(true)
      // setDummyState(true)   
      dispatch(RequisitionAction.setCartIReason(reasonCartListTemp))
    }


  }

  const onChangeQuoteAttached = (e: any, item: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < reasonListTemp.length; i++) {
      if (reasonListTemp[i]?.reasonIndex === reason?.reasonIndex) {
          reasonListTemp[i].hasQuoteAttached = item
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp))
  }

  const onChangeLinkAttachment = (event: any, attachment: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    event.preventDefault();
    event.stopPropagation();


    let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

    for (let i = 0; i < requestListTemp1.length; i++) {
      if (requestListTemp1[i] && requestListTemp1[i].reasonIndex === reason?.reasonIndex) {
        if (event.target.checked) {
          if (
            Array.isArray(requestListTemp1[i].attachments) &&
            !requestListTemp1[i].attachments.map((x: any) => x.fileName).includes(attachment?.fileName)
          ) {
            requestListTemp1[i].attachments = [...requestListTemp1[i].attachments, attachment];
          }
        } else {
          requestListTemp1[i].attachments = Array.isArray(requestListTemp1[i].attachments)
            ? requestListTemp1[i].attachments.filter((x: any) => x.fileName !== attachment?.fileName)
            : [];
        }
      }

      const isAttachment = RequisitionValidation.ValidateAttachments(requestListTemp1[i]);
      requestListTemp1[i] = { ...isAttachment.reason }
      let responseReason = RequisitionValidation.ValidateReason({ ...requestListTemp1[i] });
      requestListTemp1[i] = responseReason;
    }
    dispatch(RequisitionAction.setIReason(requestListTemp1))
  }
  const onClickDriverLinkAttachment = (e: any, index: any) => {
    setCollapse(!collapse)
    const attachmentButton: any = isDriverAttachmentBtnClicked;
    attachmentButton[index] = !attachmentButton[index];
      setIsDriverAttachmentBtnClicked([...attachmentButton])
    e.preventDefault();
    e.stopPropagation();
  }

  const onDriverCloseLinkAttachment = (e: any) => {
    setCollapse(!collapse)
    setIsDriverAttachmentBtnClicked([])
    e.preventDefault();
    e.stopPropagation();
  }

  const onClicktLinkAttachment = (e: any, index: any) => {
    const attachmentButton: any = isAttachmentBtnClicked;
    attachmentButton[index] = !attachmentButton[index];
      setIsAttachmentBtnClicked([...attachmentButton])
    e.preventDefault();
    e.stopPropagation();
  }

  const onCloseLinkAttachment = (e: any) => {
    setIsAttachmentBtnClicked([])
    e.preventDefault();
    e.stopPropagation();
  }

  const getLinkedAttachmentsCount = (reason: any) => {
    let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

    for (let i = 0; i < requestListTemp1.length; i++) {
      if (requestListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
        return requestListTemp1[i]?.attachments.length;
      }
    }

    return 0;
  }

  const updateAttachments = (items: any) => {
    setAttachmentsList(items);
  }

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const popupOutlinebtnOnclick = (item: any) => {
    hideDialog();
    setIsCancelPopup(false)
    if (item !== "") {
      dispatchNav(item);
    }
    if ((isOrderCancel || cartOrderDelete) && isCancelClicked) {
      dispatchNav(headerNav);
      
      resetOrderRequest(dispatch);
      navigate('/ordermanagement')
    }
    if (actionPopupValue.actionby === "CancelOrderBtn") {
      dispatchActionPopupValue({})
      isOrderCanceled.approval = undefined;
      dispatch(setDeleteCartOrder(null));
      setIsCancelClicked(false)
    }
  };

  const popupPrimarybtnOnclick = (
    item: any,
    comment: string,
    actionby: string,
    value: any
  ) => {
    if(orderByIdValue?.orderStatus == "Saved"){
      const deleteDraftOrder = {
          orderId: orderByIdValue?.orderId,
          comments: comment,
          savedBy: userDetails?.emailId
        };
        dispatchGetDeleteCartOrderById(deleteDraftOrder)
    }else{
    cancelOrderRequest({ orderId: orderByIdValue?.orderId, savedBy: userDetails?.emailId, comments: comment });
    }
    setIsCancelClicked(true)
    dispatchActionPopupValue({
      actionby: actionby
    });
    hideDialog();
    setIsCancelPopup(false)
  };

  const addDriverDetails = (request: any, driverDetailsList: any) => {
    let managementVehicleListtemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];

    for (let i = 0; i < managementVehicleListtemp.length; i++) {
      if (managementVehicleListtemp[i]?.requestIndex === request?.requestIndex) {
        managementVehicleListtemp[i].vehicleDriverDetails = driverDetailsList;
        let isDriver = RequisitionValidation.ValidateVehicleDriverDetails(managementVehicleListtemp[i], reasonList);
        managementVehicleListtemp[i].vehicleDriverDetailsError = isDriver.request?.vehicleDriverDetailsError;
      }
    }
    dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListtemp))
  }

  const handleClickCancel = () => {
    dispatch(RequisitionAction.isSaveClick(false));
    dispatch(RequisitionAction.isSubmitClick(false));
    dispatch(RequisitionAction.setIsOrderCreationSuccess({}));
    let decriptionTxt = (
      <p>Are you sure you want to cancel the New Order</p>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
    });
  };

  const handleClickRevert = () => {
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(getVendorDetails(""));
    APIToReact({
      dispatch,
      orderByIdValue
    })
  };

  const onClick = (e: any) => {
    e.stopPropagation();
  }

  const cancelOrderReq = (cancelOrdersubtext: any) => {
    setIsCancelPopup(true)
    setPopupcontent({
      ...Popupcontent,
      titleImg: RejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
      actionby: "CancelOrderBtn",
      href: "/ordermanagement",
    });
  };

  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  useEffect(() => {
    if ((isOrderCanceled.approval || cartOrderDelete) && isCancelClicked) {
      dispatch(RequisitionAction.setIsChangesOccured(false))
      setisOrderedCanceled(true);
      let decriptionTxt = (
        <p>Order Cancelled Successfully</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: RejectedBee,
        title: "CANCEL ORDER",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
      });
    }
    else if ((!isOrderCanceled.approval || !cartOrderDelete) && isCancelClicked) {
      let cancelorder = "Order Cancelled Failed";
      setisOrderedCanceled(false);
      setApprovalAction({
        ...approvalAction,
        cancelorder
      });
    }
  }, [isOrderCanceled?.approval, cartOrderDelete])

  const onChange = (data: any) => {
    setSelectedProductionAccordion(data);
  };
  const onChangeManagement = (data: any) => {
    setSelectedManagementAccordion(data);
  };
  const onChangeManaged = (data: any) => {
    setSelectedManagedAccordion(data);
  };
  const onChangeNonStandard = (data: any) => {
    setSelectedNonStandardAccordion(data);
  };
  

  const updateIsMandAFlag = (e: any, a: any) => {
    dispatch(RequisitionAction.setIsMandFlag(a));
  }

  const updateIsApprovalOverrideFlag = (e: any, item: any) => {
    dispatch(RequisitionAction.setIsApprovalOverrideFlag(item))
  }

  const updateIsDealerSameForAllFlag = (e: any,value : any) => {
     dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(value))
     const managedEquipmentReasons = reasonList?.filter(
      (r: any) => r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
    );
  
    const firstManagedEquipmentReason = managedEquipmentReasons[0];

    const updatedReasonList = reasonList?.map((reason: any, index: any) => {
      const shouldDisable = value &&
        reasonList?.length > 1 &&
        reasonList?.some(
          (r: any, i: any) =>
            i !== index && r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
        );
  
      if (value && reason?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
        return {
          ...reason,
          isDisabled: shouldDisable && index !== reasonList.indexOf(firstManagedEquipmentReason),
          name: firstManagedEquipmentReason?.name,
          contact: firstManagedEquipmentReason?.contact,
          phone: firstManagedEquipmentReason?.phone,
          email: firstManagedEquipmentReason?.email,
          addressLine1: firstManagedEquipmentReason?.addressLine1,
          addressLine2: firstManagedEquipmentReason?.addressLine2,
          addressLine3: firstManagedEquipmentReason?.addressLine3,
          city: firstManagedEquipmentReason?.city,
          state: firstManagedEquipmentReason?.state,
          zipCode: firstManagedEquipmentReason?.zipCode,
        };
      }
  
      return {
        ...reason,
        isDisabled: shouldDisable && reason?.requestType === CONSTANTS.MANAGED_EQUIPMENT,
      };
    });
  
    if (!value) {
      dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(false))
      updatedReasonList?.forEach((reason: any, index: any) => {
        if (reason?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
          updatedReasonList[index] = clearManagedEquipmentDetails(reason);
        }
      });
    }
  
    setReasonListTemp(updatedReasonList);
    dispatch(RequisitionAction.setIReason(updatedReasonList))
  }

  const clearManagedEquipmentDetails = (reason: any) => ({
    ...reason,
    name: '',
    contact: '',
    phone: '',
    email: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    state: '',
    zipCode: '',
    isDisabled : false
  });

  useEffect(() => {
    if(isDealerChangesOccured && isDealerSameForAllFlag){
    const managedEquipmentReasons = reasonList?.filter(
      (r: any) => r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
    );
    const firstManagedEquipmentReason = managedEquipmentReasons[0];
    const updatedReasonList = reasonList?.map((reason: any, index: any) => {
      if (isDealerSameForAllFlag && reason?.requestType === CONSTANTS.MANAGED_EQUIPMENT) {
        return {
          ...reason,
          name: firstManagedEquipmentReason?.name,
          contact: firstManagedEquipmentReason?.contact,
          phone: firstManagedEquipmentReason?.phone,
          email: firstManagedEquipmentReason?.email,
          addressLine1: firstManagedEquipmentReason?.addressLine1,
          addressLine2: firstManagedEquipmentReason?.addressLine2,
          addressLine3: firstManagedEquipmentReason?.addressLine3,
          city: firstManagedEquipmentReason?.city,
          state: firstManagedEquipmentReason?.state,
          zipCode: firstManagedEquipmentReason?.zipCode,
        };
      }else{
        return {
         ...reason
        };
      }
    });
    setReasonListTemp(updatedReasonList);
    setIsDealerChangesOccured(false)
    dispatch(RequisitionAction.setIReason(updatedReasonList))
  }
  },[isDealerChangesOccured])

  useEffect(() => {
    if (reasonList?.length > 0 && (isRequestDeleted || isReasonDeleted)) {
      const managedEquipmentReasons = reasonList?.filter(
        (r: any) => r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
      );
      const firstManagedEquipmentReason = managedEquipmentReasons[0];
    
      const updatedReasonList = reasonList?.map((reason: any, index: any) => {
        const shouldDisable = isDealerSameForAllFlag &&
          reasonList?.length > 1 &&
          reasonList?.some(
            (r: any, i: any) =>
              i !== index && r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
          );
        return {
          ...reason,
          isDisabled: shouldDisable && index !== reasonList.indexOf(firstManagedEquipmentReason)
        };
      });

    
      setReasonListTemp(updatedReasonList);
      dispatch(RequisitionAction.setIReason(updatedReasonList))
      setIsReasonDeleted(false);
      setIsRequestDeleted(false);
    }    
  }, [isReasonDeleted, isRequestDeleted]);

  const onChangeQuotePrice = (e: any, item: any, reason: any) => {
    setQuotePriceToggleBtn(e);
    let reasonListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
    for (let i = 0; i < reasonListTemp1.length; i++) {
      if (reasonListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
        if (!e) {
          reasonListTemp1[i].quotePrice = "";
          reasonListTemp1[i].estimatedPrice = "";
          reasonListTemp1[i].contact = "";
          reasonListTemp1[i].phone = "";
          reasonListTemp1[i].name = "";
          reasonListTemp1[i].email = "";
          reasonListTemp1[i].addressLine1 = "";
          reasonListTemp1[i].addressLine2 = "";
          reasonListTemp1[i].addressLine3 = "";
          reasonListTemp1[i].city = "";
          reasonListTemp1[i].state = "";
          reasonListTemp1[i].zipCode = "";
        }
        reasonListTemp1[i].showQuotePrice = e;
      }
    }
    dispatch(RequisitionAction.setIReason(reasonListTemp1))
   
  }

  //for editing the request type

  const onClickRequestType = (request : any) => {
    dispatch(RequisitionAction.setIsEditRequestClick(true))
    dispatch(RequisitionAction.setEditRequestDetails(request))
    dispatch(RequisitionAction.setIsAddRequistionTypeClick(false))
  }

  const checkManagedEquipCount = () => {
    let count = 0;
    reasonList?.map((item?: any) => {
      if(item?.requestType === CONSTANTS.MANAGED_EQUIPMENT){
      count = count + 1;
      }
    });
    return count;
  }

  return (
    <Request
      onClickResetReason={onClickResetReason}
      onClickAddToCart={onClickAddToCart}
      requestList={requestListTemp}
      productionVehicleList={productionVehicleListTemp}
      nonStandardEquipmentList={nonStandardEquipmentListTemp}
      managementVehicleList={managementVehicleListTemp}
      reasonList={reasonListTemp}
      onClickDeleteReason={onClickDeleteReason}
      onClickAddReason={onClickAddReason}
      onClickDeleteRequest={onClickDeleteRequest}
      showItemDetails={showItemDetails}
      onChangeLinkAttachment={onChangeLinkAttachment}
      onClicktLinkAttachment={onClicktLinkAttachment}
      // showReasonValidation={showReasonValidation}
      onCloseLinkAttachment={onCloseLinkAttachment}
      getLinkedAttachmentsCount={getLinkedAttachmentsCount}
      updateAttachments={updateAttachments}
      attachmentsList={attachmentsList}
      isAttachmentBtnClicked={isAttachmentBtnClicked}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      itemDetailRef={itemDetailRef}
      plannedRef={plannedRef}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      onClickDriverLinkAttachment={onClickDriverLinkAttachment}
      isDriverAttachmentBtnClicked={isDriverAttachmentBtnClicked}
      onDriverCloseLinkAttachment={onDriverCloseLinkAttachment}
      collapse={collapse}
      showCatalog={showCatalog}
      selectedRequisitionType={selectedRequisitionType}
      managedEquipmentList={managedEquipmentListTemp}
      isAttachmentRequired={isAttachmentRequired}
      addDriverDetails={addDriverDetails}
      onClick={onClick}
      handleClickCancel={handleClickCancel}
      handleClickRevert={handleClickRevert}
      isEditOrder={isEditOrder}
      orderByIdValue={orderByIdValue}
      wrapperRef={wrapperRef}
      onChange={onChange}
      selectedProductionAccordion={selectedProductionAccordion}
      onChangeManagement={onChangeManagement}
      selectedManagementAccordion={selectedManagementAccordion}
      onChangeManaged={onChangeManaged}
      selectedManagedAccordion={selectedManagedAccordion}
      onChangeNonStandard={onChangeNonStandard}
      selectedNonStandardAccordion={selectedNonStandardAccordion}
      updateIsMandAFlag={updateIsMandAFlag}
      MandAcheck={MandAcheck}
      cancelOrderReq={cancelOrderReq}
      reasonCartList={reasonCartList}
      onChangeQuotePrice={onChangeQuotePrice}
      quotePriceToggleBtn={quotePriceToggleBtn}
      onClickRequestType={onClickRequestType}
      isApprovalOverrideFlag = {isApprovalOverrideFlag}
      updateIsApprovalOverrideFlag = {updateIsApprovalOverrideFlag}
      onChangeQuoteAttached = {onChangeQuoteAttached}
      isCancelPopup = {isCancelPopup}
      isDealerSameForAllFlag = {isDealerSameForAllFlag}
      updateIsDealerSameForAllFlag = {updateIsDealerSameForAllFlag}
      setIsDealerChangesOccured = {setIsDealerChangesOccured}
      checkManagedEquipCount = {checkManagedEquipCount}
    />
  )
}

export default ItemDetailsContainer;
